import { rpcCall } from '@scayle/storefront-nuxt'
import type { IFittingHeightMapped } from '~/rpcMethods'

const data = ref<IFittingHeightMapped>()
const dataPromise = ref<Promise<IFittingHeightMapped | undefined>>()

export const useRxFittingHeight = () => {
  const nuxtApp = useNuxtApp()
  const $currentShop = useCurrentShop()
  const rpcFetch = rpcCall(nuxtApp, 'getFittingHeight', $currentShop.value)

  const fetch = (...args: Parameters<typeof rpcFetch>) => {
    data.value = undefined
    dataPromise.value = rpcFetch(...args)
  }

  const setData = (newValue: IFittingHeightMapped) => {
    data.value = newValue
  }

  const waitForData = async () => {
    const response = await dataPromise.value
    if (response && !!response?.hpd) {
      setData(response)
    }
  }

  return {
    data,
    dataPromise,
    fetch,
    setData,
    waitForData,
  }
}
